import { useVFSStore } from '@/stores/vfsStore';
import { useEffect } from 'react';
import LayoutManager from '@/components/LayoutManager';
import { TabStoreProvider } from '@/stores/tabStore';
import TopNavigation from '@/components/TopNavigation';
import { useThemeStore } from '@/stores/theme.store';

const App = () => {
  const refresh = useVFSStore(state => state.refresh);
  const { resolvedTheme } = useThemeStore();

  useEffect(() => {
    refresh();
    // Apply theme class to body
    document.body.className = resolvedTheme === 'dark' ? 'bg-gray-900' : 'bg-gray-100';
  }, [resolvedTheme]);

  return (
    <div className={`h-screen flex flex-col ${resolvedTheme === 'dark' ? 'dark' : ''}`}>
      <TopNavigation />
      <div className="flex-1">
        <TabStoreProvider>
          <LayoutManager />
        </TabStoreProvider>
      </div>
    </div>
  );
};

export default App;